// extracted by css-extract-rspack-plugin
export default {"filters":"filters-sl5Sdt"};